import { AutogenModelCarrierInsControl, AutogenRowCarrierInsControl } from "./autogen/AutogenModelCarrierInsControl";

export class ModelCarrierInsControl extends AutogenModelCarrierInsControl<RowCarrierInsControl> {
	constructor() {
		super(RowCarrierInsControl);
	}
}

export class RowCarrierInsControl extends AutogenRowCarrierInsControl {
}